<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.configuracaoRastreabilidade.plantaFabril.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.configuracaoRastreabilidade.plantaFabril.novo")',
        :exibeBotao='true',
        @btnHeaderClicado='goToCadastroPlanta'
    )
    .bloco-materiais
        .bloco-input
            .bloco-input__icon
                i.el-icon-search
            .bloco-input__input
                input.input-search(
                    v-model='filtro',
                    type='text',
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.plantaFabril.busca")',
                    autocomplete='off',
                    @keyup.enter='listarPlantasFabris()'
                )
        .bloco-listagem-materiais
            h3 {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.listagem') }}
            el-table(:key="listagemTableKey('plantas', plantas, paginacao.pagina + 1)", :data='plantas')
                el-table-column(
                    prop='id',
                    :label='$t("mensagens.configuracaoRastreabilidade.plantaFabril.tabela.id")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.id || '-' }}
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.configuracaoRastreabilidade.plantaFabril.tabela.nome")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}
                
                el-table-column(
                    prop='commodity',
                    :label='$t("mensagens.configuracaoRastreabilidade.plantaFabril.tabela.commodity")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.commodity || '-' }}
                
                el-table-column(
                    prop='descricaoMaterial',
                    :label='$t("mensagens.configuracaoRastreabilidade.plantaFabril.tabela.subproduto")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.descricaoMaterial || '-' }}
            
                el-table-column(
                    :label='$t("mensagens.comuns.acoes")',
                    align='center',
                    width='90'
                )
                    .template.d-flex.justify-content-center.tabela-material-icone(
                        slot-scope='scope'
                    )
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='visualizar(scope.row.id)'
                                ) {{ $t('mensagens.comuns.visualizar') }}
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='editar(scope.row)'
                                ) {{ $t('mensagens.comuns.editar') }}
                template(slot='empty')
                el-empty(
                    :description='$t("mensagens.configuracaoRastreabilidade.materiais.semDados")'
                )
        .bloco-paginacao
            span {{ paginacao.total }} {{ paginacao.total > 1 ? $t('mensagens.configuracaoRastreabilidade.materiais.materiais') : $t('mensagens.configuracaoRastreabilidade.materiais.material') }}
            el-pagination(
                background,
                :page-size='paginacao.itensPorPagina',
                :current-page.sync='paginacao.pagina + 1',
                layout='prev, pager, next',
                :total='paginacao.total',
                @current-change='listarPlantasFabris'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import services from '@/views/contratos-originacao/planta-fabril/services';

export default {
    name: 'ConfiguracaoPlanta',
    components: {
        BaseHeader
    },
    data() {
        return {
            filtro: '',
            pageable: {
                page: 0,
                size: 5,
                sort: 'nome',
                order: 'asc'
            },
            plantas: [],
            paginacao: {}
        };
    },
    mounted() {
        this.listarPlantasFabris();
    },
    methods: {
        confirmarRemocao(id) {
            this.$confirm(
                this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.confirmarRemocao'),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            ).then(() => {
                this.removerPlanta(id);
            }).catch(() => {});
        },
        async removerPlanta(id) {
            try {
                await services.deletarPlantaFabril(id);
                this.$notify.success(
                    this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.removidoSucesso')
                );
                this.listarPlantasFabris();
            } catch (error) {
                this.$notify.error(
                    this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.erroRemover')
                );
            }
        },
        async listarPlantasFabris(page = 1) {
            this.pageable.page = page - 1;
            const params = {
                filtro: { nome: this.filtro },
                pageable: this.pageable
            };

            const { data } = await services.buscarPlantasFabrisPorFiltro(
                params
            );
            this.plantas = data.plantas;
            this.paginacao = data.paginacao;
        },
        mudarPagina(page) {
            this.listarPlantasFabris(page);
        },
        goToCadastroPlanta() {
            this.$router.push({ name: 'CadastroPlanta' });
        },
        visualizar(id) {
            this.$router.push({
                name: 'DetalhePlanta',
                params: { id }
            });
        },
        editar(planta) {
            this.$router.push({
                name: 'CadastroPlanta',
                params: { id: planta.id }
            });
        }
    }
};
</script>

<style lang="scss">
.bloco-materiais {
    margin: 20px;
}

.bloco-input {
    display: flex;
    background-color: $white;
    padding: 7px 10px;
    border-radius: $default-border-radius;
    gap: 5px;
    align-items: center;
    @include default-box-shadow();
}

.bloco-input__icon i {
    color: $primary;
}

.bloco-input__input {
    flex: 1;

    input {
        border: 0 !important;
        outline: 0;
        width: 100%;
    }
}

.bloco-listagem-materiais {
    margin-top: 20px;

    h3 {
        margin-bottom: 5px;
    }

    .el-table {
        border-radius: 4px 4px 0 0;
        @include default-box-shadow();
    }
}

.bloco-paginacao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: $white;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    span {
        color: $primary;
        font-weight: bold;
    }
}

.tabela-material-icone {
    i {
        font-size: 27px;
    }
}
</style>
